import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  taskId: string;
  taskTitle?: string;
}

const TaskFolderBanner: React.FC<Props> = ({ taskId, taskTitle }) => {
  const { t } = useTranslation('files');
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="flex items-center justify-between px-4 py-2 mb-3 bg-indigo-50 border border-indigo-200 rounded-lg">
      <div className="flex items-center gap-2 text-sm text-indigo-700">
        <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
        <span>
          {t('taskBanner.taskFiles', 'Task files:')} <strong>{taskId}</strong>
          {taskTitle && <span className="text-indigo-500 ml-1">- {taskTitle}</span>}
        </span>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate(`/tasks/${taskId}`)}
          className="text-xs text-indigo-600 hover:text-indigo-800 font-medium"
        >
          {t('taskBanner.viewTask', 'View Task')}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-indigo-400 hover:text-indigo-600"
          title={t('taskBanner.dismiss', 'Dismiss')}
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TaskFolderBanner;
